document.addEventListener('DOMContentLoaded', function () {
  calculateCurrentInventory();
  setInterval(calculateCurrentInventory, 300000); // 5 minutes
});

function calculateCurrentInventory() {
  const stockStatusEl = document.getElementById('stock__status_num');
  const statusLineEl = document.getElementById('stock__status_line');
  const graphContainer = document.querySelector('.stock--graph');

  const INITIAL_INVENTORY = stockStatusEl.getAttribute('data-custom-inventory');
  const MIN_INVENTORY = 3;
  const MAX_INVENTORY = 42;
  const DECREASE_INTERVAL_DAYS = 5;
  const START_DATE = new Date('2025-03-05');

  let currentInventory;
  let displayText = '';
  let activeCircle;
  let statusClass = '';
  let glowColor = '';

  // Reset UI state
  document.querySelectorAll('.status_wrapper').forEach(wrapper => {
      wrapper.classList.remove('active', 'passed');
  });
  statusLineEl.innerHTML = '';
  statusLineEl.classList.remove('full-status', 'normal-status', 'low-status');
  if (graphContainer) graphContainer.style.boxShadow = '';

  // Highlight the correct circle
  document.querySelectorAll('.status_circle').forEach(circle => {
      circle.style.animation = '';
      circle.style.boxShadow = '';
  });

  // Handle explicit out-of-stock condition
if (INITIAL_INVENTORY === '0') {
  displayText = ''
  statusClass = 'low-status'; 
  statusLineEl.classList.add('out-of-stock'); // 👈 Add this line
} else {
  statusLineEl.classList.remove('out-of-stock'); // 👈 Remove class when not out of stock

      // Parse initial inventory
      const initialInv = parseInt(INITIAL_INVENTORY, 10);

      // Calculate inventory decrease over time
      const stepTimeMs = Math.floor(DECREASE_INTERVAL_DAYS * 1000 * 60 * 60 * 24 / (MAX_INVENTORY - MIN_INVENTORY));
      const currentDate = new Date();
      const timeDifference = currentDate - START_DATE;
      const intervalsPassed = Math.floor(timeDifference / stepTimeMs);
      const intervalsPassedReminder = intervalsPassed % MAX_INVENTORY;

      currentInventory = initialInv - intervalsPassedReminder;

      if (currentInventory < MIN_INVENTORY) {
          const deficit = MIN_INVENTORY - currentInventory;
          currentInventory = MAX_INVENTORY - deficit;
      }

      // Determine UI behavior based on inventory level
      if (currentInventory > 20) {
          displayText = `${currentInventory} Items in Stock. Produced in Small Batches.`;
          activeCircle = 'status_green';
          statusClass = 'full-status';
          glowColor = 'rgba(4, 238, 43, 0.21)';
      } else if (currentInventory > 9) {
          displayText = `Only ${currentInventory} left. Produced in small batches.`;
          activeCircle = 'status_yellow';
          statusClass = 'normal-status';
          glowColor = 'rgba(254, 211, 24, 0.21)';
      } else {
          displayText = `Only ${currentInventory} left in stock. Final call!`;
          activeCircle = 'status_red';
          statusClass = 'low-status';
          glowColor = 'rgba(255, 88, 51, 0.21)';
      }
  }

  // Update status line text and class
  statusLineEl.innerHTML = displayText;
  statusLineEl.classList.add(statusClass);

  // Apply glow effect to graph container
  if (graphContainer && glowColor) {
      graphContainer.style.boxShadow = `0 0 0 .5rem ${glowColor}`;
  }

  // Handle active circle animation
  if (activeCircle) {
      const activeWrapper = document.querySelector(`#${activeCircle}`)?.closest('.status_wrapper');
      if (activeWrapper) {
          activeWrapper.classList.add('active');
          const activeCircleEl = activeWrapper.querySelector('.status_circle');
          if (activeCircleEl) {
              // Define glow pulse animation
              const pulseKeyframes = [
                  { boxShadow: `0 0 0 0 ${glowColor}` },
                  { boxShadow: `0 0 0 8px ${glowColor}` },
                  { boxShadow: `0 0 0 0 ${glowColor}` }
              ];

              // Set duration based on color
              let pulseDuration = 2000;
              if (activeCircle === 'status_red') {
                  pulseDuration = 800;
              } else if (activeCircle === 'status_yellow') {
                  pulseDuration = 1000;
              }

              // Animate
              activeCircleEl.animate(pulseKeyframes, {
                  duration: pulseDuration,
                  easing: 'ease-in-out',
                  iterations: Infinity
              });
          }
      }
  }
}





$(document).ready(function () {
  const $slider = $('.product_reviewss_customm .custom-review-section');
  const $customNav = $('.product_reviewss_customm .custom-slider-nav');

  function initDesktopSlider() {
    const slideCount = $slider.children().length;

    if ($(window).width() > 992 && slideCount > 2) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          infinite: false,
          autoplay: true,
          speed: 2000,
          autoplaySpeed: 2000,
        });

        $customNav.show();

        $('.custom-prev').off('click').on('click', function () {
          $slider.slick('slickPrev');
        });
        $('.custom-next').off('click').on('click', function () {
          $slider.slick('slickNext');
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      $customNav.hide();
    }
  }

  initDesktopSlider();

  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initDesktopSlider, 250);
  });
});





 
  jQuery(document).ready(function($) {
  function initMobileSlider() {
    const $slider = $('.slide_pro_ident .custom-product-overview');

    // Initialize slider only if not already initialized
    if ($(window).width() <= 749) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          adaptiveHeight: true,
        });
      }
    } else {
      // Destroy slider above mobile breakpoint
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  // Run on load
  initMobileSlider();

  // Re-run on window resize
  $(window).on('resize', function() {
    initMobileSlider();
  });
});





function initIdentiboltSlider() {
  var $slider = $('.identibolt_pro_mainn .main_mbl_slide');

  if ($(window).width() <= 749) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

$(document).ready(initIdentiboltSlider);

$(window).on('resize', function() {
  initIdentiboltSlider();
});

